import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create')({
  beforeLoad: () => getTitleContextSlice('Create'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
